import { render, staticRenderFns } from "./SidebarBrand.vue?vue&type=template&id=24970949&scoped=true&"
import script from "./SidebarBrand.vue?vue&type=script&lang=js&"
export * from "./SidebarBrand.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBrand.vue?vue&type=style&index=0&id=24970949&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24970949",
  null
  
)

export default component.exports